<template>
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
      >
        <div class="back" @click="$router.go(-1)">
          <div><i class="el-icon-back"></i></div>
        </div>
        <el-form-item label="所属部门" prop="bmbh">
          <el-select
            ref="bmmc"
            v-model="listQuery.bmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in zxlc.bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="bmmc"
            v-model="listQuery.xmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in zxlc.xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同状态" prop="htzt">
          <el-select
            ref="name"
            v-model="listQuery.htzt"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in zxlc.htztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="申请人">
          <treeselect
            v-model="listQuery.sqr"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 200px; line-height: 32px"
            size="small"
          />
        </el-form-item>
        <el-form-item label="是否发函" prop="name">
          <el-select
            ref="name"
            v-model="listQuery.fhzt"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option label="不发函" value="0" />
            <el-option label="发函" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="发函结果" prop="lcjd">
          <el-select
            ref="lcjd"
            v-model="listQuery.lcjd"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in zxlc.fhjgList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >搜 索</el-button
          >
        </span>
        <span style="margin-top: 4px; margin-left: 15px; display: inline-block">
          <el-button size="small" @click="reset()">重 置</el-button>
        </span>
      </el-form>
      <div style="margin: 10px 0">
        <el-button
          type="primary"
          size="small"
          @click="handleToApply()"
          v-if="user.bntqxzt == 2"
          >一把手变更发函申请</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 15px"
          size="small"
          @click="exportList()"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <div>
        <el-table
          v-loading="listLoading"
          :data="zxlc.ybsbgfhList.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :max-height="height"
        >
          <el-table-column
            label="所属部门"
            prop="bmmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="项目名称"
            prop="xmjc"
            :show-overflow-tooltip="true"
            min-width="150px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="申请人"
            prop="sqr"
            :show-overflow-tooltip="true"
            min-width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.sqr ? scope.row.sqr : "-" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="申请时间"
            prop="sqsj"
            min-width="100px"
            align="center"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.sqsj ? scope.row.sqsj : "-" }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="是否发函"
            prop="fhztmc"
            min-width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="发函结果"
            prop="fyjg"
            min-width="100px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="由区域总监进行发函确认 由效果办专员进行发函处理"
                placement="top"
              >
                <div>
                  发函结果&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div
                v-if="scope.row.fyjg == '已处理'"
                @click="handleToView(scope.row, true)"
                style="
                  color: #52c41a;
                  text-decoration: underline;
                  cursor: pointer;
                "
              >
                已处理
              </div>
              <div
                v-if="scope.row.fyjg == '待处理'"
                @click="handleToView(scope.row)"
                style="
                  color: #c6d70a;
                  text-decoration: underline;
                  cursor: pointer;
                "
              >
                待处理
              </div>
              <div class="" v-else-if="scope.row.fyjg == '待确认'">
                <el-popover
                  placement="top"
                  trigger="click"
                  :disabled="user.bntqxzt != 2"
                >
                  <div
                    style="
                      font-weight: 700;
                      line-height: 32px;
                      margin-bottom: 5px;
                    "
                  >
                    {{ scope.row.xmjc }}续约发函确认
                  </div>
                  <div style="display: flex; justify-content: space-around">
                    <el-button size="mini" @click="handleWxfh(scope.row)"
                      >无需发函</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="handleToApply(scope.row)"
                      >需要发函</el-button
                    >
                  </div>
                  <div
                    slot="reference"
                    style="
                      color: #c6d70a;
                      text-decoration: underline;
                      cursor: pointer;
                    "
                  >
                    待确认
                  </div>
                </el-popover>
              </div>
              <div
                v-if="scope.row.fyjg == '不发函'"
                style="color: rgba(0, 0, 0, 0.2)"
              >
                不发函
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="合同状态"
            prop="htzt"
            min-width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="合同起止日期"
            prop="htzq"
            min-width="160px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="合作期限(年)"
            prop="hznx"
            min-width="110px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="确认人"
            prop="qdr"
            min-width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="确认时间"
            prop="qd_time"
            min-width="160px"
            align="center"
          >
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="zxlc.ybsbgfhList.total > 0"
          :total="zxlc.ybsbgfhList.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="一把手变更发函申请"
      :visible.sync="applyDialog"
      width="90%"
      v-if="applyDialog"
      id="mx-dialog"
    >
      <ApplyForm
        ref="apply"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></ApplyForm>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit(1)">提 交</el-button>
        <el-button @click="applyDialog = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`一把手变更发函${this.mxParams.isView ? '查看' : '处理'}`"
      :visible.sync="viewDialog"
      width="90%"
      v-if="viewDialog"
      id="mx-dialog"
    >
      <ViewForm ref="view" @giveFather="getSon" :mxParams="mxParams"></ViewForm>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="handleConfirm()"
          v-if="!this.mxParams.isView"
          >确认发函完成</el-button
        >
        <el-button @click="viewDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import ApplyForm from "./applyForm.vue";
import ViewForm from "./viewForm.vue";
import { ybsbgfhExport, updateXmxyfh } from "@/api/zxlc";
export default {
  // 列表分页
  name: "xmxyList",
  components: { Treeselect, Pagination, ApplyForm, ViewForm },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc", "xgpg"]),
  },
  data: () => {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      mxParams: {},
      height: 800,
      listQuery: {
        bmbh: null,
        xmbh: null,
        htzt: null,
        sqr: null,
        xyjd: null,
        fhzt: null,
        lcjd: null,
        page: 1,
        pageSize: 20,
      },
      listLoading: false,
      applyDialog: false,
      viewDialog: false,
      mxParams: {},
      roleName: "",
      dclVisible: false,
      canClick: true,
    };
  },
  created() {
    this.$store.dispatch("common/fetchUserInfoAction");

    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }

    if (this.zxlc.htztList.length == 0) {
      this.$store.dispatch("zxlc/fetchHtztListAction", {
        dictType: "htzt",
        type: 2,
      });
    }
    if (this.zxlc.fhjgList.length == 0) {
      this.$store.dispatch("zxlc/fetchFhjgListAction", {
        dictType: "pmp_xm_fhjg",
      });
    }
    if (this.zxlc.bmList.length == 0) {
      this.$store.dispatch("zxlc/fetchBmListAction", { type: 2, range: 1 });
    }
    this.$store.dispatch("zxlc/fetchXmxxListAction", {
      range: 1,
      bmbh: this.listQuery.bmbh,
    });
    if (this.$route.query.lcjd) {
      this.listQuery.lcjd = this.$route.query.lcjd;
    }
    // if (this.user.bntqxzt == 2) {
    //   this.listQuery.bmbh = this.user.bmbh;
    // }
    this.getList();
  },
  methods: {
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{
          bmbh: null,
          xmbh: null,
          htzt: null,
          sqr: null,
          xyjd: null,
          fhzt: null,
          lcjd: null,
        },
      };
      this.$store.dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        bmbh: this.listQuery.bmbh,
      });
    },
    getList() {
      this.listLoading = true;
      this.$store
        .dispatch("zxlc/fetchYbsbgfhListAction", { ...this.listQuery })
        .then((res) => {
          if (res.code == 0) {
            this.listLoading = false;
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 75;
          }
        });
    },
    handleChangeBm(e) {
      this.$store.dispatch("zxlc/fetchXmxxListAction", { range: 1, bmbh: e });
      this.listQuery.xmbh = null;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleToView(row, isView) {
      // if (row.fyjg == "待处理" && this.user.bntqxzt != 1) return;
      if (row.fyjg == "待确认" && this.user.bntqxzt != 2) return;
      this.viewDialog = true;
      this.mxParams = row;
      this.mxParams.isView = isView;
      if (row.fyjg == "待处理" && this.user.bntqxzt != 1) {
        this.mxParams.isView = true;
      }
    },
    handleSaveEdit() {
      this.$refs.edit.handleEdit();
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    getSon() {
      this.applyDialog = false;
      this.viewDialog = false;
      this.getList();
    },
    handleChangeStatus() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSubmit() {
      this.$refs.apply.submitUpload();
    },
    exportList() {
      const { bmbh, xmbh, htzt, sqr, xyjd, fhzt, lcjd } = this.listQuery;
      ybsbgfhExport({ bmbh, xmbh, htzt, sqr, xyjd, fhzt, lcjd }).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath; // 组装a标签
          const elink = document.createElement("a"); // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleWxfh(row) {
      if (this.canClick == false) return;
      this.canClick = false;
      updateXmxyfh({ id: row.id, fhlx: 2 }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.dclVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
        this.canClick = true;
      });
    },
    handleToApply(row) {
      this.applyDialog = true;
      this.mxParams = row;
    },
    handleConfirm() {
      this.$refs.view.submitUpload();
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

